export const ASYNC_KEY = {
  userInfo: 'usr_info',
  accessToken: 'isToken',
};

export const API_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export const DEFAULT_IMAGE = null;

export const notificationTypes = [
  "GENERAL",
  "BATCH_JOIN",
  "BATCH_REVIEW_ADDED",
  "CHAT_REQUEST_RECEIVE",
  "CHAT_REQUEST_SEND",
  "REQUIREMENT_CREATE",
  "PAYMENT_METHOD_ADDED",
  "PAYMENT_CHARGED",
];

export const maximumFeesBatch = process.env.REACT_APP_MAXIMUMFEESBATCH || 200;
